var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feedback-form" },
    [
      _c("SlideYDownTransition", [
        _vm.feedbackHasBeenSent === true
          ? _c("h6", { staticClass: "u-txt-c u-mv" }, [
              _vm._v(_vm._s(_vm.customSuccesMessage))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("SlideYUpTransition", [
        _vm.feedbackHasBeenSent !== true
          ? _c(
              "div",
              [
                _vm._t("callToAction", [
                  _c("h6", { staticClass: "u-txt-c u-mv" }, [
                    _vm._v(_vm._s(_vm.customCta))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "textarea-wrapper" },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.feedback,
                          expression: "feedback"
                        }
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: "2",
                        placeholder: _vm.customTextareaPlaceholder
                      },
                      domProps: { value: _vm.feedback },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.feedback = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._t("submitButton", [
                      _c(
                        "ElButton",
                        {
                          staticClass: "inline-submit-btn",
                          attrs: {
                            size: "mini",
                            type: "text",
                            disabled: _vm.feedback.length === 0
                          },
                          on: { click: _vm.submitFeedback }
                        },
                        [
                          _vm._v("\n            Verstuur\n            "),
                          _c("i", {
                            staticClass:
                              "fas fa-chevron-right u-ml-10 u-color--tertiary"
                          })
                        ]
                      )
                    ])
                  ],
                  2
                )
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }